import React, { FC } from 'react';

import { Props } from './Message.types';

export const Message: FC<Props> = ({ className, message }) => {
  return <span className={className}>{message}</span>;
};
